import React, { useState } from 'react';
import { FiXCircle } from "react-icons/fi"
import Calendar from './Calendar';
import { time12 } from '../functions/functions';
export default function CalendarDetail(props) {
    const { eventDates, venueBookDates, myvenueBookDates, serBks, booked, home, setLayout } = props;
    const [selectedDate, selectDate] = useState(null);
    function Item(props) {
        const { item, } = props;
        if (booked) {
            return (
                <div style={{ paddingBlock: 2, marginLeft: 10, flexDirection: 'row', alignItems: 'center' }}>
                    <p style={{ color: 'white', fontWeight: 'bold' }}>Artist is Booked from {time12(new Date(item.start))} till {time12(new Date(item.end))}</p>
                </div>
            );
        } else {
            return (
                <div style={{ paddingBlock: 2, marginLeft: 10, flexDirection: 'row', alignItems: 'center' }}>
                    <div style={{
                        justifyContent: 'flex-end',
                        marginRight: 10,
                    }}>
                        <p style={{ color: 'white' }} >{time12(new Date(item.start))}</p>
                        <div style={{ borderBottomColor: 'white', borderBottomWidth: 1, width: '100%', marginBlock: 2 }} />
                        <p style={{ color: 'white' }} >{time12(new Date(item.end))}</p>
                    </div>
                    <div>
                        {item.name && item.type ? <p style={{ color: 'white', fontWeight: 'bold' }}>{item.name} - {item.type}</p> :
                            <p style={{ color: 'white', fontWeight: 'bold' }}> Private event</p>}
                        {item.venueName ? <p style={{ color: 'white' }}>{'@'} {item.venueName} </p> : null}
                    </div>
                </div>
            );
        }
    }
    return (
        <div
        // onLayout={({ nativeEvent }) => {
        //     if (setLayout) { setLayout(nativeEvent.layout) }
        // }}
        >
            <Calendar
                date={selectedDate}
                setDate={selectDate}
                onlyActive={true}
                eventDates={eventDates}
                venueBookDates={venueBookDates}
                myvenueBookDates={myvenueBookDates}
                serBks={serBks}
            />
            {selectedDate && <div style={{ padding: 10, alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                    <hr style={{ borderBottom: '1px solid var(--ltg)', marginBlock: 5, width: '40%' }} />
                    <p style={{color:'var(--ltg)', cursor: 'pointer'}} onClick={() => { selectDate(null);  }}>Hide <FiXCircle  style={{color:'var(--ltg)'}} /></p>
                    
                    <hr style={{ borderBottom: '1px solid var(--ltg)',  marginBlock: 5, width: '40%'  }} />
                </div>
                <div>
                    {selectedDate.events && selectedDate.events.length > 0 &&
                        <div style={{ paddingBlock: 2 }}>
                            <p style={{ fontSize: 16, color: 'var(--prl)', fontWeight: 'bold' }}>Events:</p>
                            {selectedDate.events.map(item => <Item key={item.name} color={'var(--prl)'} item={item} />)}
                        </div>}
                    {selectedDate.venueBookings && selectedDate.venueBookings.length > 0 &&
                        <div style={{ paddingBlock: 2 }}>
                            <p style={{ fontSize: 16, color: 'var(--org)', fontWeight: 'bold' }}>{home ? 'Subscriptions' : 'Venue Bookings'}:</p>
                            {selectedDate.venueBookings.map(item => <Item key={item.name + item.start} color={'var(--org)'} item={item} />)}
                        </div>}
                    {selectedDate.myvenueBookings && selectedDate.myvenueBookings.length > 0 &&
                        <div style={{ paddingBlock: 2 }}>
                            <p style={{ fontSize: 16, color: 'var(--wht)', fontWeight: 'bold' }}>My Venue Bookings:</p>
                            {selectedDate.myvenueBookings.map(item => <Item key={item.name + item.start} color={'var(--wht)'} item={item} />)}
                        </div>}
                    {selectedDate.serBks && selectedDate.serBks.length > 0 &&
                        <div style={{ paddingBlock: 2 }}>
                            <p style={{ fontSize: 16, color: 'var(--yel)', fontWeight: 'bold' }}>{booked ? 'Availability' : 'My Services Bookings'}:</p>
                            {selectedDate.serBks.map(item => <Item key={item.name + item.start} color={'var(--yel)'} item={item} />)}
                        </div>}
                </div>
            </div>}
        </div>
    );
}
